import { PhotoBackground } from "./PhotoBackground";
import { get } from "micro-dash";
import mediaPlaceholder from "../../../assets/media_placeholder.svg";
import styles from "./Block.module.scss";
import React from "react";

export const DoublePhoto = ({
    block,
    alternativePlaceholderImage,
    showBlockPhotoUploadModal,
    allowPhotoUpload = true,
}) => (
    <div className="tile is-12 is-vertical">
        <div className="tile is-12 is-parent">
            <div className="tile is-child">
                <PhotoBackground
                    url={get(
                        block,
                        ["photos", "0", "fileName"],
                        mediaPlaceholder
                    )}
                    extraClassName={styles.isDouble}
                    mediaPlaceholder={mediaPlaceholder}
                    alternativePlaceholderImage={alternativePlaceholderImage}
                    showBlockPhotoUploadModal={() =>
                        showBlockPhotoUploadModal(block.id)
                    }
                    allowPhotoUpload={allowPhotoUpload}
                />
            </div>
        </div>
        <div className="tile is-12 is-parent">
            <div className="tile is-child">
                <PhotoBackground
                    url={get(
                        block,
                        ["photos", "1", "fileName"],
                        mediaPlaceholder
                    )}
                    extraClassName={styles.isDouble}
                    showBlockPhotoUploadModal={() =>
                        showBlockPhotoUploadModal(block.id)
                    }
                    allowPhotoUpload={allowPhotoUpload}
                />
            </div>
        </div>
    </div>
);
